import cx from 'classnames';
import React from 'react';

import * as styles from './SVGWrapper.module.css';

const SVGWrapper = ({
	className,
	width = 'auto',
	height = 'auto',
	maxwidth = 'auto',
	maxheight = 'auto',
	children,
}: {
	className?: string;
	width?: string;
	height?: string;
	maxwidth?: string;
	maxheight?: string;
	children: React.ReactNode;
}) => {
	return (
		<div
			className={cx(className, styles.wrapper)}
			style={{
				width: width,
				height: height,
				maxWidth: maxwidth,
				maxHeight: maxheight,
			}}
		>
			{children}
		</div>
	);
};

export default SVGWrapper;
